<div class="panel panel-default" id="translate" >
	<div class="panel-heading">
		<h1 class="d-block">
			{{ 'statistic' | translate }} {{ 'par_pays_edit' | translate }}:
		</h1>
	</div>
	<div class="panel-body">
		<div class="tz-gallery col-12 py-0">
        <form #f="ngForm" (ngSubmit)="onSearch(f.value)" class="form-inline">   
            <table class="table">
                    <tr class="row">
                        <td class="bold col-12 col-xl-4">
                            <label class="text-left">{{ 'pays_org' | translate }} : </label>
                            <select name="pays" required ngModel class="form-control form-control-sm w-100">
                                <option value=" " selected>{{ 'chosepays' | translate }}</option>
                                <option  *ngFor="let y of paysedition" value='{{ y.paysedition }}'>
                                    {{ y.paysedition }}
                                </option>
                            </select>
                        </td> 
                        <td class="bold col-12 col-xl-4">
                            <label class="text-left">{{ 'annee_edition' | translate }} : {{ 'entre' | translate }}</label>
                            <select name="first"  ngModel class="form-control form-control-sm w-100" (change)="onchangeDate($event.target.value)">
                                <option disabled selected>{{ 'chosedate' | translate }}</option>
                                <option *ngFor="let y of years">{{ y }}</option>
                            </select>
                        </td>
                        <td class="bold col-12 col-xl-4">
                            <label class="text-left">{{ 'et' | translate }}</label>
                            <select name="end" ngModel class="form-control form-control-sm w-100">
                                <option disabled selected>{{ 'chosedate' | translate }}</option>
                                <option *ngFor="let y of years2">{{ y }}</option>
                            </select>
                        </td> 
                        <td class="bold col-12 col-xl-4">
                            <label class="text-left">{{ 'limit' | translate }} :</label>
                            <select name="limit" ngModel class="form-control form-control-sm w-100">
                                <option value="10" ng-selected="selected">10</option>
                                <option value="20">20</option>
                                <option value="30">30</option>
                                <option value="50">50</option>
                            </select>
                        </td> 
                        <td class="bold col-12 col-xl-4">  
                            <label class="text-left">{{ 'dspchart' | translate }} : <span *ngIf="chartrequired" class="text-danger mx-2"> {{ 'required' | translate }} </span></label>
                            <select name="charts" class="form-control form-control-sm w-100" ngModel >
                                <option [value]="''" ></option>
                                <!-- <option [value]="'ALL'" >{{ 'all' | translate}}</option> -->
                                <!-- <option [value]="'TM'" >{{ 'TM' | translate }}</option> -->
                                <!-- <option [value]="'DME'" >{{ 'DME' | translate }}</option> -->
                                <option [value]="'annees_edition'" >{{ 'annees_edition' | translate }}</option>
                                <option [value]="'thematiques'" >{{ 'thematiques' | translate }}</option>
                                <option [value]="'langues_source'" >{{ 'langues_source' | translate }}</option>
                                <!-- <option [value]="'TDT'" >{{ 'TDT' | translate }}</option> -->
                                <option [value]="'palmas_trads'" >{{ 'palmas_trads' | translate }}</option>
                                <option [value]="'palmas_editors'" >{{ 'palmas_editors' | translate }}</option>
                                <option [value]="'palmas_authors'" >{{ 'palmas_authors' | translate }}</option>
                                <!-- <option [value]="'NT'" >{{ 'NT' | translate }}</option>
                                <option [value]="'TPN'" >{{ 'TPN' | translate }}</option> -->
                            </select>
                        </td> 
                    </tr> 
            </table>
            <button class="btn btn-success my-3" type="submit">{{ 'display' | translate }}</button>
        </form>

		</div>
    </div>
	<div class="panel-body">
		<div class="tz-gallery col-12 py-0">
            <div class="row">
                <div class="col-6 mmc" *ngIf="this.pays_org && charts == 'annees_edition'">
                    <div class="card card-info">
                        <div class="card-header py-1 pointer">{{ 'annees_edition' | translate }}</div>
                        <div class="card-body py-10">
                            <!-- <app-tabyaeredit [linkv]="linktm" ></app-tabyaeredit> -->
                            <app-charteyears [linkv]="linktm" [lcount]="total"></app-charteyears>
                        </div>
                    </div>
                </div>
                <div class="col-6 mmc" *ngIf="this.pays_org && charts == 'thematiques'">
                    <div class="card card-info">
                        <div class="card-header py-1 pointer">{{ 'thematiques' | translate }}</div>
                        <div class="card-body">                            
                            <app-chartedition [linkv]="linkdescip" [lcount]="total" [namec]="'thematiques' | translate" [namecol]="'thematiques'"></app-chartedition>
                        </div>
                    </div>
                </div>
                <div class="col-6 mmc" *ngIf="this.pays_org && charts == 'langues_source'">
                    <div class="card card-info">
                        <div class="card-header py-1 pointer">{{ 'langues_source' | translate }}</div>
                        <div class="card-body py-10">
                            <app-chartedition [linkv]="linklangsrc" [lcount]="total" [namec]="'langues_source' | translate" [namecol]="'langues_source'"></app-chartedition>
                        </div>
                    </div>
                </div>
                <div class="col-6 mmc" *ngIf="this.pays_org && charts == 'palmas_trads'">
                    <div class="card card-info">
                        <div class="card-header py-1 pointer">{{ 'palmas_trads' | translate }}</div>
                        <div class="card-body py-10">
                            <app-chartedition [linkv]="linktrad" [lcount]="total" [namec]="'palmas_trads' | translate" [namecol]="'traducteurs'"></app-chartedition>
                        </div>
                    </div>
                </div>
                <div class="col-6 mmc" *ngIf="this.pays_org && charts == 'palmas_editors'">
                    <div class="card card-info">
                        <div class="card-header py-1 pointer">{{ 'palmas_editors' | translate }}</div>
                        <div class="card-body py-10">
                            <app-chartedition [linkv]="linkeditor" [lcount]="total" [namec]="'palmas_editors' | translate" [namecol]="'editeurs'"></app-chartedition>
                        </div>
                    </div>
                </div>
                <div class="col-6 mmc" *ngIf="this.pays_org && charts == 'palmas_authors'">
                    <div class="card card-info">
                        <div class="card-header py-1 pointer">{{ 'palmas_authors' | translate }}</div>
                        <div class="card-body py-10">
                            <app-chartedition [linkv]="linkauthor" [lcount]="total" [namec]="'palmas_authors' | translate" [namecol]="'auteurs'"></app-chartedition>
                        </div>
                    </div>
                </div>
                <!-- <div class="col-12 col-xl-4 my-4">
                    <div class="card card-info">
                        <div class="card-header py-1 pointer">{{ 'TA' | translate }}</div>
                        <div class="card-body py-10">
                            <app-chartedition [linkv]="linkta" [namec]="'TA' | translate" [namecol]="'langues_source' | translate"></app-chartedition>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-xl-4 my-4">
                    <div class="card card-info">
                        <div class="card-header py-1 pointer">{{ 'TDA' | translate }}</div>
                        <div class="card-body py-10">
                            <app-chartedition [linkv]="linktda" [namec]="'TDA' | translate" [namecol]="'langues_cible' | translate"></app-chartedition>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-xl-4 my-4">
                    <div class="card card-info">
                        <div class="card-header py-1 pointer">{{ 'editeurs' | translate }}</div>
                        <div class="card-body">
                            <app-chartedition [linkv]="linkediteur" [namec]="'editeurs' | translate" [namecol]="'editeurs' | translate"></app-chartedition>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-xl-4 my-4" >
                    <div class="card card-info">
                        <div class="card-header py-1 pointer">{{ 'pays_org' | translate }}</div>
                        <div class="card-body">
                            <app-chartedition [linkv]="linkpays" [namec]="'pays_org' | translate" [namecol]="'pays_org' | translate"></app-chartedition>
                        </div>
                    </div>
                </div> -->
            </div>
        </div>
    </div>
    
</div>